import { PROVISIONED_UI_FLAGS } from '@Admin/constants'

import { DefaultRootState } from '~/types'
import isFlagEnabled from '~/lib/isFlagEnabled'
import { getUserIdentity } from '~/redux-modules/identity'

export const selectFlags = (state: DefaultRootState) => {
    const identity = getUserIdentity(state)

    return {
        isImMaafcoEnabled: isFlagEnabled(
            identity,
            PROVISIONED_UI_FLAGS.IM_MAAFCO_UI,
            'true',
        ),
        isCpqFlagV2Enabled: isFlagEnabled(
            identity,
            PROVISIONED_UI_FLAGS.UI_CPQ_QUOTES_INTEGRATION_V2,
            'true',
        ),
    }
}
